import { Details } from "../pages/main/query/topic/products/product-detail";

export default interface VehiclesModel {
    id: number
    PH: string
    name: string
    source: string
    minimum: number
    maximum: number
    favorite: boolean
    description: string
    incompatibility: string
    mechanism_action: string
}

export type VehicleViewModel = {
    id?: number,
    name: string,
    description: string,
    mechanism_action: string,
    PH: string,
    incompatibility: string,
    minimum: string,
    maximum: string,
    source: string,
    favorite?: boolean,
    enabled?: boolean,
}

export const vehiclesToProductDetail = (vehicle: VehiclesModel | VehicleViewModel | null | undefined) => {
    return {
        name: vehicle?.name,
        mechanism: vehicle?.mechanism_action,
        description: vehicle?.description,
        ph: vehicle?.PH,
        incompatibility: vehicle?.incompatibility,
        minimum: vehicle?.minimum,
        maximum: vehicle?.maximum,
        source: vehicle?.source,
    } as Details
}
